<template>
<div>
    <van-nav-bar title="加班管理" left-text="返回" @click-left="back" fixed left-arrow style="z-index:1000" />
<div class="content">
    <van-tabs v-model="active" @change="activeChange">
        <van-tab title="加班申请" :name="0" v-if="overtimeFil"></van-tab>
        <van-tab title="加班单列表" :name="1"></van-tab>
        <van-tab title="加班审核" :name="2" v-if="overtimeAudit"></van-tab>
    </van-tabs>

    <!-- 加班申请填报 -->
    <div class="edit" v-if="active == 0">
        <van-form class="edit_form" ref="addForm" label-width="110px">
            <!-- 加班日期 -->
            <van-field
                v-model="addForm.date"
                label="加班日期"
                readonly
                clickable
                required
                :rules="[{ required: true, message: '请选择加班日期' }]"
                @click="showDatePicker = true">
                <template #input><span>{{ addForm.date }}</span></template>
            </van-field>
            <van-calendar v-model="showDatePicker" :show-confirm="false" @confirm="onDateConfirm" :min-date="minDate" :max-date="maxDate" />

            <!-- 对应班次 -->
            <van-field
                v-model="addForm.shiftType"
                label="对应班次"
                readonly
                clickable
                required
                :rules="[{ required: true, message: '请选择对应班次' }]"
                @click="showShiftPicker = true">
                <template #input><span>{{ shiftTypeLabel(addForm.shiftType) }}</span></template>
            </van-field>
            <van-popup v-model="showShiftPicker" position="bottom">
                <van-picker
                    show-toolbar
                    :columns="shiftTypeList"
                    value-key="label"
                    @confirm="onShiftConfirm"
                    @cancel="showShiftPicker = false" />
            </van-popup>

            <!-- 开始时间 -->
            <!-- <van-field
                v-model="addForm.startTime"
                label="开始时间"
                readonly
                clickable
                required
                :rules="[{ required: true, message: '请选择开始时间' }]"
                @click="showStartTimePicker = true">
                <template #input><span>{{ addForm.startTime }}</span></template>
            </van-field>
            <van-popup v-model="showStartTimePicker" position="bottom">
                <van-datetime-picker
                    type="datetime"
                    title="选择开始时间"
                    v-model="startTimeDate"
                    :min-date="minDate"
                    :max-date="maxDate"
                    :filter="datetimeFilter"
                    @confirm="onStartTimeConfirm"
                    @cancel="showStartTimePicker = false" />
            </van-popup> -->

            <!-- 结束时间 -->
            <!-- <van-field
                v-model="addForm.endTime"
                label="结束时间"
                readonly
                clickable
                required
                :rules="[{ required: true, message: '请选择结束时间' }]"
                @click="showEndTimePicker = true">
                <template #input><span>{{ addForm.endTime }}</span></template>
            </van-field>
            <van-popup v-model="showEndTimePicker" position="bottom">
                <van-datetime-picker
                    type="datetime"
                    title="选择结束时间"
                    v-model="endTimeDate"
                    :min-date="minDate"
                    :max-date="maxDate"
                    :filter="datetimeFilter"
                    @confirm="onEndTimeConfirm"
                    @cancel="showEndTimePicker = false" />
            </van-popup> -->

            <!-- 申请加班时长 -->
            <van-field
                v-model="addForm.durationDisplay"
                label="加班时长(小时)"
                type="number"
                placeholder="请填写加班时长"
                required
                :rules="[{ required: true, message: '请填写加班时长' }, { validator: validateDuration, message: '加班时长必须大于0' }]"
                @blur="syncDurationFromDisplay">
            </van-field>

            <!-- 加班事由 -->
            <van-field
                v-model="addForm.reason"
                label="加班事由"
                type="textarea"
                :autosize="{minHeight: 80}"
                required
                :rules="[{ required: true, message: '请输入加班事由' }]"
                maxlength="200"
                show-word-limit>
            </van-field>

            <!-- 作废当日其他申请单 -->
            <van-field label="作废当日其他申请单">
                <template #input>
                    <van-checkbox v-model="addForm.forceCancelOthers" shape="square">勾选后提交将作废当日其他加班申请单</van-checkbox>
                </template>
            </van-field>

            <!-- 证明材料 -->
            <van-field label="证明材料">
                <template #input>
                    <van-uploader
                        v-model="fileList"
                        :after-read="uploaderAfterRead"
                        :max-count="3"
                        multiple
                        :before-delete="imgDeleteFile"
                        accept="image/*" />
                </template>
            </van-field>
        </van-form>

        <!-- 提交按钮 -->
        <div class="form_btn" style="position:fixed; bottom:0px; width:100%;">
            <div style="padding-bottom:10px;">
                <van-button square block type="info" @click="submitOvertime()" :loading="submitLoading" style="width:100%;float:left;">提交申请</van-button>
            </div>
        </div>
    </div>

    <!-- 加班单列表 -->
    <div class="list" v-if="active == 1">
        <van-collapse v-model="activeName" accordion class="list_collapse">
            <van-collapse-item v-for="item in overtimeList" :key="item.id" :name="item.id">
                <template #title>
                    <div class="collapse_label_l">申请人：
                        <span v-if="user.userNameNeedTranslate == 1"><TranslationOpenDataText type='userName' :openid='item.userName'></TranslationOpenDataText></span>
                        <span v-else>{{ item.userName }}</span>
                    </div>
                    <div class="collapse_label_r">加班日期：{{ item.date }}</div>
                    <div class="collapse_label_l">加班时长：{{ formatDuration(item.duration) }}</div>
                    <div class="collapse_label_r">状态：<span :class="getStatusClass(item.status)">{{ getStatusText(item.status) }}</span></div>
                </template>
                <div class="wrapper">
                    <div><span>对应班次：</span><span>{{ shiftTypeLabel(item.shiftType, item.isNightShift) }}</span></div>
                    <!-- <div><span>开始时间：</span><span>{{ item.startTime }}</span></div>
                    <div><span>结束时间：</span><span>{{ item.endTime }}</span></div> -->
                    <div><span>加班时长：</span><span>{{ formatDuration(item.duration) }}</span></div>
                    <div><span>加班事由：</span><span>{{ item.reason }}</span></div>
                    <div v-if="item.status === 3"><span>驳回原因：</span><span style="color:#ee0a24">{{ item.denyReason }}</span></div>
                    <div v-if="item.file">
                        <span>证明材料：</span>
                        <van-uploader v-model="item.fileUrlsList" :max-count="0" :deletable="false" />
                    </div>
                </div>
                <div class="operation">
                    <!-- 待HR审核时，申请人本人可撤回 -->
                    <van-button
                        v-if="item.status === 0 && item.userId === user.id"
                        size="small" type="default"
                        @click="withdrawRecord(item)">撤回</van-button>
                    <!-- 驳回或已撤回时，申请人可编辑重新提交 -->
                    <van-button
                        v-if="(item.status === 3 || item.status === -1) && item.userId === user.id"
                        size="small" type="info"
                        style="margin-left:8px"
                        @click="editRecord(item)">编辑</van-button>
                    <!-- 驳回或已撤回时，申请人或有删除权限者可删除 -->
                    <van-button
                        v-if="(item.status === 3 || item.status === -1) && (item.userId === user.id || overtimeDelete)"
                        size="small" type="danger"
                        style="margin-left:8px"
                        @click="deleteRecord(item)">删除</van-button>
                    <!-- 已通过时，有撤销已通过权限者可撤销 -->
                    <van-button
                        v-if="item.status === 2 && overtimeWithdrawPass"
                        size="small" type="warning"
                        style="margin-left:8px"
                        @click="withdrawPassRecord(item)">撤销已通过</van-button>
                </div>
            </van-collapse-item>
        </van-collapse>
        <div v-if="overtimeList.length === 0 && !listLoading" class="empty-tip">
            <van-empty description="暂无加班记录" />
        </div>
    </div>

    <!-- 加班审核 -->
    <div class="audit" v-if="active == 2">
        <van-collapse v-model="auditName" accordion class="list_collapse">
            <van-collapse-item v-for="item in auditList" :key="item.id" :name="item.id">
                <template #title>
                    <div class="collapse_label_l">申请人：
                        <span v-if="user.userNameNeedTranslate == 1"><TranslationOpenDataText type='userName' :openid='item.userName'></TranslationOpenDataText></span>
                        <span v-else>{{ item.userName }}</span>
                    </div>
                    <div class="collapse_label_r">加班日期：{{ item.date }}</div>
                    <div class="collapse_label_l">加班时长：{{ formatDuration(item.duration) }}</div>
                    <div class="collapse_label_r">状态：<span :class="getStatusClass(item.status)">{{ getStatusText(item.status) }}</span></div>
                    <div class="operation">
                        <van-button size="small" type="info" :loading="item.approveLoading" @click.stop="approvePass(item)">通过</van-button>
                        <van-button style="margin-left:10px" size="small" type="danger" @click.stop="openDenyDialog(item.id)">驳回</van-button>
                    </div>
                </template>
                <div class="wrapper">
                    <div><span>对应班次：</span><span>{{ shiftTypeLabel(item.shiftType, item.isNightShift) }}</span></div>
                    <!-- <div><span>开始时间：</span><span>{{ item.startTime }}</span></div>
                    <div><span>结束时间：</span><span>{{ item.endTime }}</span></div> -->
                    <div><span>加班时长：</span><span>{{ formatDuration(item.duration) }}</span></div>
                    <div><span>加班事由：</span><span>{{ item.reason }}</span></div>
                    <div v-if="item.file">
                        <span>证明材料：</span>
                        <van-uploader v-model="item.fileUrlsList" :max-count="0" :deletable="false" />
                    </div>
                </div>
            </van-collapse-item>
        </van-collapse>
        <div v-if="auditList.length === 0 && !auditLoading" class="empty-tip">
            <van-empty description="暂无待审核记录" />
        </div>

        <!-- 驳回原因弹窗 -->
        <van-popup v-model="denyReasonDialog" position="bottom" closeable>
            <van-cell>请输入驳回原因</van-cell>
            <van-field
                v-model="denyParm.denyReason"
                type="textarea"
                placeholder="请输入您决定驳回的原因"
                rows="3"
                autosize />
            <van-button style="width:100%;" type="info" :loading="denyLoading" @click="submitDeny()">提交</van-button>
        </van-popup>
    </div>
</div>

<!-- 编辑弹窗 -->
<van-popup v-model="editDialog" position="bottom" :style="{ height: '90%' }" closeable>
    <div style="padding: 16px; padding-top: 40px; overflow-y: auto; height: 100%; box-sizing: border-box;">
        <div style="font-size: 16px; font-weight: bold; margin-bottom: 16px; text-align: center;">编辑加班申请</div>
        <van-form ref="editForm" label-width="110px">
            <!-- 加班日期 -->
            <van-field
                v-model="editItemForm.date"
                label="加班日期"
                readonly
                clickable
                required
                :rules="[{ required: true, message: '请选择加班日期' }]"
                @click="showEditDatePicker = true">
                <template #input><span>{{ editItemForm.date }}</span></template>
            </van-field>
            <van-calendar v-model="showEditDatePicker" :show-confirm="false" @confirm="onEditDateConfirm" :min-date="minDate" :max-date="maxDate" />

            <!-- 对应班次 -->
            <van-field
                v-model="editItemForm.shiftType"
                label="对应班次"
                readonly
                clickable
                required
                :rules="[{ required: true, message: '请选择对应班次' }]"
                @click="showEditShiftPicker = true">
                <template #input><span>{{ shiftTypeLabel(editItemForm.shiftType) }}</span></template>
            </van-field>
            <van-popup v-model="showEditShiftPicker" position="bottom">
                <van-picker
                    show-toolbar
                    :columns="shiftTypeList"
                    value-key="label"
                    @confirm="onEditShiftConfirm"
                    @cancel="showEditShiftPicker = false" />
            </van-popup>

            <!-- 开始时间 -->
            <!-- <van-field
                v-model="editItemForm.startTime"
                label="开始时间"
                readonly
                clickable
                required
                :rules="[{ required: true, message: '请选择开始时间' }]"
                @click="showEditStartTimePicker = true">
                <template #input><span>{{ editItemForm.startTime }}</span></template>
            </van-field>
            <van-popup v-model="showEditStartTimePicker" position="bottom">
                <van-datetime-picker
                    type="datetime"
                    title="选择开始时间"
                    v-model="editStartTimeDate"
                    :min-date="minDate"
                    :max-date="maxDate"
                    :filter="datetimeFilter"
                    @confirm="onEditStartTimeConfirm"
                    @cancel="showEditStartTimePicker = false" />
            </van-popup> -->

            <!-- 结束时间 -->
            <!-- <van-field
                v-model="editItemForm.endTime"
                label="结束时间"
                readonly
                clickable
                required
                :rules="[{ required: true, message: '请选择结束时间' }]"
                @click="showEditEndTimePicker = true">
                <template #input><span>{{ editItemForm.endTime }}</span></template>
            </van-field>
            <van-popup v-model="showEditEndTimePicker" position="bottom">
                <van-datetime-picker
                    type="datetime"
                    title="选择结束时间"
                    v-model="editEndTimeDate"
                    :min-date="minDate"
                    :max-date="maxDate"
                    :filter="datetimeFilter"
                    @confirm="onEditEndTimeConfirm"
                    @cancel="showEditEndTimePicker = false" />
            </van-popup> -->

            <!-- 申请加班时长 -->
            <van-field
                v-model="editItemForm.durationDisplay"
                label="加班时长(小时)"
                type="number"
                placeholder="请填写加班时长"
                required
                :rules="[{ required: true, message: '请填写加班时长' }, { validator: validateDuration, message: '加班时长必须大于0' }]"
                @blur="syncEditDurationFromDisplay">
            </van-field>

            <!-- 加班事由 -->
            <van-field
                v-model="editItemForm.reason"
                label="加班事由"
                type="textarea"
                :autosize="{minHeight: 80}"
                required
                :rules="[{ required: true, message: '请输入加班事由' }]"
                maxlength="200"
                show-word-limit>
            </van-field>

            <!-- 作废当日其他申请单 -->
            <van-field label="作废当日其他申请单">
                <template #input>
                    <van-checkbox v-model="editItemForm.forceCancelOthers" shape="square">勾选后提交将作废当日其他加班申请单</van-checkbox>
                </template>
            </van-field>

            <!-- 证明材料 -->
            <van-field label="证明材料">
                <template #input>
                    <van-uploader
                        v-model="editFileList"
                        :after-read="editUploaderAfterRead"
                        :max-count="3"
                        multiple
                        :before-delete="editImgDeleteFile"
                        accept="image/*" />
                </template>
            </van-field>
        </van-form>
        <div style="padding: 16px 0 60px 0;">
            <van-button block type="info" @click="submitEdit()" :loading="editLoading">提交</van-button>
        </div>
    </div>
</van-popup>

</div>
</template>

<script>
export default {
    name: 'OvertimeManage',
    data() {
        return {
            user: JSON.parse(localStorage.userInfo),
            // 权限
            overtimeFil: false,
            overtimeAudit: false,
            overtimeDelete: false,
            overtimeWithdrawPass: false,

            active: 1,

            // 日期范围
            minDate: new Date(2020, 0, 1),
            maxDate: new Date(2030, 11, 31),

            // 班次列表
            shiftTypeList: [
                { label: '白班 8:00-17:00', value: 'day' },
                { label: '白班2 8:30-17:30', value: 'day2' },
                { label: '夜班 0:00-8:00', value: 'night' },
                { label: '小夜班 16:00-24:00', value: 'night_small' },
                { label: '夜班2 20:00-次日04:00', value: 'night2' },
            ],

            // 新增表单
            addForm: {
                date: '',
                shiftType: 'day',
                startTime: '',
                endTime: '',
                duration: null,
                durationDisplay: null,
                durationType: 'hour',
                reason: '',
                file: null,
                isNightShift: false,
                status: 0,
                forceCancelOthers: false
            },
            showDatePicker: false,
            showShiftPicker: false,
            showStartTimePicker: false,
            showEndTimePicker: false,
            startTimeDate: new Date(),
            endTimeDate: new Date(),
            fileList: [],
            serverFileList: [],
            submitLoading: false,

            // 加班单列表
            overtimeList: [],
            activeName: '',
            listLoading: false,

            // 加班审核列表
            auditList: [],
            auditName: '',
            auditLoading: false,
            denyReasonDialog: false,
            denyLoading: false,
            denyParm: {
                id: '',
                denyReason: ''
            },

            // 编辑弹窗
            editDialog: false,
            editItemForm: {},
            editFileList: [],
            editServerFileList: [],
            editLoading: false,
            showEditDatePicker: false,
            showEditShiftPicker: false,
            showEditStartTimePicker: false,
            showEditEndTimePicker: false,
            editStartTimeDate: new Date(),
            editEndTimeDate: new Date(),
        }
    },
    mounted() {
        // 解析权限
        for (let i in this.user.functionList) {
            const name = this.user.functionList[i].name
            if (name === '加班填报' || name === '加班申请') {
                this.overtimeFil = true
            }
            if (name === '一级审核' || name === '二级审核') {
                this.overtimeAudit = true
            }
            if (name === '删除加班单') {
                this.overtimeDelete = true
            }
            if (name === '撤销已通过') {
                this.overtimeWithdrawPass = true
            }
        }

        // 初始化默认 tab
        if (this.overtimeFil) {
            this.active = 0
            this.initAddForm()
        } else if (this.overtimeAudit) {
            this.active = 2
            this.getAuditList()
        } else {
            this.active = 1
        }
        // 无论默认哪个 tab，都预加载列表数据
        this.getOvertimeList()
    },
    methods: {
        back() {
            history.back()
        },

        // tab 切换
        activeChange() {
            if (this.active == 1) {
                this.getOvertimeList()
            } else if (this.active == 2) {
                this.getAuditList()
            }
        },

        // 初始化新增表单
        initAddForm() {
            const today = this.formatDate(new Date())
            this.addForm = {
                date: today,
                shiftType: 'day',
                startTime: today + ' 19:00:00',
                endTime: today + ' 22:00:00',
                duration: null,
                durationDisplay: null,
                durationType: 'hour',
                reason: '',
                file: null,
                isNightShift: false,
                status: 0,
                forceCancelOthers: false
            }
            this.fileList = []
            this.serverFileList = []
            const startDefault = new Date()
            startDefault.setHours(19, 0, 0, 0)
            this.startTimeDate = startDefault
            const endDefault = new Date()
            endDefault.setHours(22, 0, 0, 0)
            this.endTimeDate = endDefault
            this.calcDuration()
        },

        // 格式化日期
        formatDate(date) {
            const y = date.getFullYear()
            const m = String(date.getMonth() + 1).padStart(2, '0')
            const d = String(date.getDate()).padStart(2, '0')
            return `${y}-${m}-${d}`
        },

        // 格式化日期时间
        formatDateTime(date) {
            const dateStr = this.formatDate(date)
            const h = String(date.getHours()).padStart(2, '0')
            const min = String(date.getMinutes()).padStart(2, '0')
            const s = String(date.getSeconds()).padStart(2, '0')
            return `${dateStr} ${h}:${min}:${s}`
        },

        // 班次标签
        shiftTypeLabel(shiftType, isNightShift) {
            const found = this.shiftTypeList.find(s => s.value === shiftType)
            if (found) return found.label
            if (isNightShift) return '夜班'
            return '白班 8:00-17:00'
        },

        // 状态文字
        getStatusText(status) {
            const map = {
                0: '待HR审核',
                1: '待部门审核',
                2: '审核通过',
                3: '审核驳回',
                4: '已作废',
                '-1': '已撤回'
            }
            return map[status] !== undefined ? map[status] : '未知'
        },

        // 状态样式
        getStatusClass(status) {
            if (status === 2) return 'status-pass'
            if (status === 3) return 'status-reject'
            if (status === 0 || status === 1) return 'status-waiting'
            if (status === 4) return 'status-void'
            return ''
        },

        // 格式化时长
        formatDuration(seconds) {
            if (seconds == null) return '/'
            return (seconds / 3600).toFixed(2) + ' 小时'
        },

        // 校验时长
        validateDuration(val) {
            const v = parseFloat(val)
            return !isNaN(v) && v > 0
        },

        // 获取文件列表（用于展示）
        getFileList(fileStr) {
            if (!fileStr) return []
            return fileStr.split(',').map(name => ({
                url: `/upload/${name}`,
                name: name
            }))
        },

        // ===== 新增表单 - 日期/时间选择 =====
        onDateConfirm(date) {
            this.addForm.date = this.formatDate(date)
            this.showDatePicker = false
            // 同步开始/结束时间的日期部分
            if (this.addForm.startTime) {
                const timePart = this.addForm.startTime.substring(10)
                this.addForm.startTime = this.addForm.date + timePart
            }
            if (this.addForm.endTime) {
                const timePart = this.addForm.endTime.substring(10)
                this.addForm.endTime = this.addForm.date + timePart
            }
            this.calcDuration()
        },

        onShiftConfirm(item) {
            this.addForm.shiftType = item.value
            this.showShiftPicker = false
        },

        // 时间选择器过滤（只保留整点，不显示分钟和秒）
        datetimeFilter(type, values) {
            if (type === 'minute' || type === 'second') {
                return ['00']
            }
            return values
        },

        onStartTimeConfirm(date) {
            date.setMinutes(0, 0, 0)
            this.addForm.startTime = this.formatDateTime(date)
            this.showStartTimePicker = false
            this.calcDuration()
        },

        onEndTimeConfirm(date) {
            date.setMinutes(0, 0, 0)
            this.addForm.endTime = this.formatDateTime(date)
            this.showEndTimePicker = false
            this.calcDuration()
        },

        // 计算加班时长（新增表单）
        calcDuration() {
            if (this.addForm.startTime && this.addForm.endTime) {
                const start = new Date(this.addForm.startTime.replace(/-/g, '/'))
                const end = new Date(this.addForm.endTime.replace(/-/g, '/'))
                const diffMs = end - start
                if (diffMs > 0) {
                    let diffHours = diffMs / (1000 * 60 * 60)
                    const lunchDeduct = this.calcLunchDeduction(this.addForm.startTime, this.addForm.endTime)
                    if (lunchDeduct > 0) {
                        diffHours = Math.max(0, diffHours - lunchDeduct)
                    }
                    this.addForm.duration = Math.round(diffHours * 3600)
                    this.addForm.durationDisplay = diffHours.toFixed(2)
                } else if (diffMs < 0) {
                    this.addForm.duration = null
                    this.addForm.durationDisplay = null
                    this.$toast('结束时间不能早于开始时间')
                }
            }
        },

        // 手动修改时长后同步（新增表单）
        syncDurationFromDisplay() {
            const hours = parseFloat(this.addForm.durationDisplay)
            if (!isNaN(hours) && hours > 0) {
                this.addForm.duration = Math.round(hours * 3600)
                this.addForm.durationDisplay = hours.toFixed(2)
            } else {
                this.addForm.duration = null
                this.addForm.durationDisplay = null
            }
        },

        // 计算午休扣除时长
        calcLunchDeduction(startTimeStr, endTimeStr) {
            const start = new Date(startTimeStr.replace(/-/g, '/'))
            const end = new Date(endTimeStr.replace(/-/g, '/'))
            const lunchStart = new Date(start)
            lunchStart.setHours(12, 0, 0, 0)
            const lunchEnd = new Date(start)
            lunchEnd.setHours(13, 0, 0, 0)
            if (start < lunchStart && end > lunchStart) {
                const overlapEnd = end < lunchEnd ? end : lunchEnd
                return (overlapEnd - lunchStart) / (1000 * 60 * 60)
            }
            return 0
        },

        // ===== 文件上传（新增表单）=====
        uploaderAfterRead(fileOrList) {
            const files = Array.isArray(fileOrList) ? fileOrList : [fileOrList]
            this.$toast('上传中...')
            files.forEach(item => {
                const formData = new FormData()
                formData.append('multipartFile', item.file)
                this.$axios.post('/common/uploadFile', formData)
                    .then(res => {
                        this.$toast.clear()
                        if (res.code === 'ok') {
                            this.serverFileList.push({ originName: item.file.name, serverName: res.data })
                            this.addForm.file = this.serverFileList.map(f => f.serverName).join(',')
                        } else {
                            this.$toast.fail(res.msg)
                        }
                    }).catch(err => {
                        this.$toast.clear()
                        console.log(err)
                    })
            })
        },

        imgDeleteFile(file, detail) {
            const idx = detail.index
            this.serverFileList.splice(idx, 1)
            this.addForm.file = this.serverFileList.map(f => f.serverName).join(',') || null
            return true
        },

        // ===== 提交新增申请 =====
        submitOvertime() {
            this.$refs.addForm.validate().then(() => {
                const submitData = Object.assign({}, this.addForm)
                submitData.isNightShift = submitData.shiftType !== 'day' && submitData.shiftType !== 'day2'
                delete submitData.durationDisplay
                this.submitLoading = true
                this.$axios.post('/overtime/add', submitData)
                    .then(res => {
                        this.submitLoading = false
                        if (res.code === 'ok') {
                            this.$toast.success('加班申请提交成功')
                            this.initAddForm()
                            this.$refs.addForm && this.$refs.addForm.resetValidation()
                        } else {
                            this.$toast.fail(res.msg)
                        }
                    }).catch(err => {
                        this.submitLoading = false
                        this.$toast.clear()
                        console.log(err)
                    })
            }).catch(() => {})
        },

        // ===== 加班单列表 =====
        getOvertimeList() {
            this.listLoading = true
            this.$axios.post('/overtime/getList', {
                pageIndex: 1,
                pageSize: 999
            }).then(res => {
                this.listLoading = false
                if (res.code === 'ok') {
                    this.overtimeList = (res.data.records || []).map(item => {
                        return Object.assign({}, item, {
                            fileUrlsList: item.file
                                ? item.file.split(',').map(name => ({ url: `/upload/${name}`, name }))
                                : []
                        })
                    })
                } else {
                    this.$toast.fail('获取失败：' + res.msg)
                }
            }).catch(err => {
                this.listLoading = false
                this.$toast.clear()
                console.log(err)
            })
        },

        // 撤回申请
        withdrawRecord(item) {
            this.$dialog.confirm({ message: '确认撤回该加班申请？' })
                .then(() => {
                    this.$axios.post('/overtime/withdraw?id=' + item.id, {})
                        .then(res => {
                            if (res.code === 'ok') {
                                this.$toast.success('撤回成功')
                                this.getOvertimeList()
                            } else {
                                this.$toast.fail(res.msg)
                            }
                        }).catch(err => { console.log(err) })
                }).catch(() => {})
        },

        // 删除记录
        deleteRecord(item) {
            this.$dialog.confirm({ message: '确认删除该加班申请？' })
                .then(() => {
                    this.$axios.post('/overtime/delete?id=' + item.id, {})
                        .then(res => {
                            if (res.code === 'ok') {
                                this.$toast.success('删除成功')
                                this.getOvertimeList()
                            } else {
                                this.$toast.fail(res.msg)
                            }
                        }).catch(err => { console.log(err) })
                }).catch(() => {})
        },

        // 编辑记录
        editRecord(row) {
            const editData = Object.assign({}, row)
            if (!editData.shiftType) {
                editData.shiftType = editData.isNightShift ? 'night' : 'day'
            }
            if (editData.duration) {
                editData.durationDisplay = (editData.duration / 3600).toFixed(2)
            }
            if (editData.forceCancelOthers == null) {
                editData.forceCancelOthers = false
            }
            this.editItemForm = editData
            // 初始化编辑文件列表
            this.editServerFileList = []
            this.editFileList = []
            if (editData.file) {
                editData.file.split(',').forEach(serverName => {
                    this.editServerFileList.push({ originName: serverName, serverName })
                    this.editFileList.push({ name: serverName, url: `/upload/${serverName}` })
                })
            }
            // 初始化时间选择器的默认值
            if (editData.startTime) {
                this.editStartTimeDate = new Date(editData.startTime.replace(/-/g, '/'))
            }
            if (editData.endTime) {
                this.editEndTimeDate = new Date(editData.endTime.replace(/-/g, '/'))
            }
            this.editDialog = true
        },

        // ===== 编辑表单 - 日期/时间选择 =====
        onEditDateConfirm(date) {
            this.$set(this.editItemForm, 'date', this.formatDate(date))
            this.showEditDatePicker = false
            if (this.editItemForm.startTime) {
                const timePart = this.editItemForm.startTime.substring(10)
                this.$set(this.editItemForm, 'startTime', this.editItemForm.date + timePart)
            }
            this.calcEditDuration()
        },

        onEditShiftConfirm(item) {
            this.$set(this.editItemForm, 'shiftType', item.value)
            this.showEditShiftPicker = false
        },

        onEditStartTimeConfirm(date) {
            date.setMinutes(0, 0, 0)
            this.$set(this.editItemForm, 'startTime', this.formatDateTime(date))
            this.showEditStartTimePicker = false
            this.calcEditDuration()
        },

        onEditEndTimeConfirm(date) {
            date.setMinutes(0, 0, 0)
            this.$set(this.editItemForm, 'endTime', this.formatDateTime(date))
            this.showEditEndTimePicker = false
            this.calcEditDuration()
        },

        // 计算加班时长（编辑表单）
        calcEditDuration() {
            if (this.editItemForm.startTime && this.editItemForm.endTime) {
                const start = new Date(this.editItemForm.startTime.replace(/-/g, '/'))
                const end = new Date(this.editItemForm.endTime.replace(/-/g, '/'))
                const diffMs = end - start
                if (diffMs > 0) {
                    let diffHours = diffMs / (1000 * 60 * 60)
                    const lunchDeduct = this.calcLunchDeduction(this.editItemForm.startTime, this.editItemForm.endTime)
                    if (lunchDeduct > 0) {
                        diffHours = Math.max(0, diffHours - lunchDeduct)
                    }
                    this.editItemForm.duration = Math.round(diffHours * 3600)
                    this.$set(this.editItemForm, 'durationDisplay', diffHours.toFixed(2))
                } else if (diffMs < 0) {
                    this.editItemForm.duration = null
                    this.$set(this.editItemForm, 'durationDisplay', null)
                    this.$toast('结束时间不能早于开始时间')
                }
            }
        },

        // 手动修改时长后同步（编辑表单）
        syncEditDurationFromDisplay() {
            const hours = parseFloat(this.editItemForm.durationDisplay)
            if (!isNaN(hours) && hours > 0) {
                this.editItemForm.duration = Math.round(hours * 3600)
                this.$set(this.editItemForm, 'durationDisplay', hours.toFixed(2))
            } else {
                this.editItemForm.duration = null
                this.$set(this.editItemForm, 'durationDisplay', null)
            }
        },

        // ===== 文件上传（编辑表单）=====
        editUploaderAfterRead(fileOrList) {
            const files = Array.isArray(fileOrList) ? fileOrList : [fileOrList]
            this.$toast('上传中...')
            files.forEach(item => {
                const formData = new FormData()
                formData.append('multipartFile', item.file)
                this.$axios.post('/common/uploadFile', formData)
                    .then(res => {
                        this.$toast.clear()
                        if (res.code === 'ok') {
                            this.editServerFileList.push({ originName: item.file.name, serverName: res.data })
                            this.editItemForm.file = this.editServerFileList.map(f => f.serverName).join(',')
                        } else {
                            this.$toast.fail(res.msg)
                        }
                    }).catch(err => {
                        this.$toast.clear()
                        console.log(err)
                    })
            })
        },

        editImgDeleteFile(file, detail) {
            const idx = detail.index
            this.editServerFileList.splice(idx, 1)
            this.editItemForm.file = this.editServerFileList.map(f => f.serverName).join(',') || null
            return true
        },

        // 提交编辑
        submitEdit() {
            this.$refs.editForm.validate().then(() => {
                const submitData = Object.assign({}, this.editItemForm)
                submitData.isNightShift = submitData.shiftType !== 'day' && submitData.shiftType !== 'day2'
                delete submitData.durationDisplay
                // 重新提交时重置状态
                if (submitData.status === 3 || submitData.status === -1) {
                    submitData.status = 0
                    submitData.denyReason = null
                }
                this.editLoading = true
                this.$axios.post('/overtime/update', submitData)
                    .then(res => {
                        this.editLoading = false
                        if (res.code === 'ok') {
                            this.editDialog = false
                            this.$toast.success('修改成功')
                            this.getOvertimeList()
                        } else {
                            this.$toast.fail(res.msg)
                        }
                    }).catch(err => {
                        this.editLoading = false
                        console.log(err)
                    })
            }).catch(() => {})
        },

        // ===== 加班审核 =====
        getAuditList() {
            this.auditLoading = true
            this.$axios.post('/overtime/getAuditList', {
                pageIndex: 1,
                pageSize: 999,
                status: 0
            }).then(res => {
                this.auditLoading = false
                if (res.code === 'ok') {
                    this.auditList = (res.data.records || []).map(item => {
                        return Object.assign({}, item, {
                            approveLoading: false,
                            fileUrlsList: item.file
                                ? item.file.split(',').map(name => ({ url: `/upload/${name}`, name }))
                                : []
                        })
                    })
                } else {
                    this.$toast.fail('获取失败：' + res.msg)
                }
            }).catch(err => {
                this.auditLoading = false
                console.log(err)
            })
        },

        // 审核通过
        approvePass(item) {
            item.approveLoading = true
            this.$axios.post('/overtime/approve?id=' + item.id + '&isPass=1', {})
                .then(res => {
                    item.approveLoading = false
                    if (res.code === 'ok') {
                        this.$toast.success('审核通过')
                        this.getAuditList()
                    } else {
                        this.$toast.fail(res.msg)
                    }
                }).catch(err => {
                    item.approveLoading = false
                    console.log(err)
                })
        },

        // 打开驳回弹窗
        openDenyDialog(id) {
            this.denyParm = { id, denyReason: '' }
            this.denyReasonDialog = true
        },

        // 撤销已通过
        withdrawPassRecord(item) {
            this.$dialog.confirm({ message: '确定要撤回该已通过的加班申请吗？' })
                .then(() => {
                    this.$axios.post('/overtime/withdrawPass?id=' + item.id, {})
                        .then(res => {
                            if (res.code === 'ok') {
                                this.$toast.success('撤回成功')
                                this.getOvertimeList()
                            } else {
                                this.$toast.fail(res.msg)
                            }
                        }).catch(err => { console.log(err) })
                }).catch(() => {})
        },

        // 提交驳回
        submitDeny() {
            if (!this.denyParm.denyReason) {
                this.$toast('请输入驳回原因')
                return
            }
            this.denyLoading = true
            this.$axios.post('/overtime/approve?id=' + this.denyParm.id + '&isPass=0&denyReason=' + encodeURIComponent(this.denyParm.denyReason), {})
                .then(res => {
                    this.denyLoading = false
                    if (res.code === 'ok') {
                        this.denyReasonDialog = false
                        this.$toast.success('已驳回')
                        this.getAuditList()
                    } else {
                        this.$toast.fail(res.msg)
                    }
                }).catch(err => {
                    this.denyLoading = false
                    console.log(err)
                })
        }
    }
}
</script>

<style lang="less" scoped>
.content {
    margin-top: 46px;
    overflow: auto;

    .edit {
        padding-bottom: 60px;
        .form_btn {
            z-index: 1000;
        }
    }

    .list, .audit {
        .list_collapse > div {
            margin: 4px;
        }
        .list_collapse {
            .collapse_label_l {
                width: 50%;
                padding: 4px;
                display: inline-block;
            }
            .collapse_label_r {
                width: 50%;
                padding: 4px;
                display: inline-block;
            }
            .wrapper {
                div {
                    margin: 8px 16px;
                    zoom: 1;
                }
                div:after {
                    content: "";
                    display: block;
                    height: 0;
                    clear: both;
                    visibility: hidden;
                }
                div span:nth-child(1) {
                    width: 40%;
                    float: left;
                }
                div span:nth-child(2) {
                    width: 60%;
                    float: left;
                }
            }
            .operation {
                margin-top: 8px;
                padding-top: 8px;
                border-top: 0.5px solid #ebedf0;
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }
        }
    }

    .empty-tip {
        padding: 40px 0;
    }
}

.status-pass {
    color: #07c160;
}
.status-reject {
    color: #ee0a24;
}
.status-waiting {
    color: #ff976a;
}
.status-void {
    color: #969799;
}
</style>
<style>
.edit_form .van-field__label {
    color: #646566;
}
</style>
